var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-expansion-panels',_vm._l((_vm.content),function(item,i){return _c('v-expansion-panel',{key:i},[_c('v-expansion-panel-header',[_vm._v(" "+_vm._s(item.title)+" ")]),_c('v-expansion-panel-content',[_c('div',{domProps:{"innerHTML":_vm._s(item.content)}})])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }